import React from 'react'
import IconPricing from '@/components/IconPricing'

type TProps = {
  priceRange: string
}

function PriceRangeDisplay({ priceRange }: TProps): JSX.Element {
  return (
    <div className="flex items-center gap-2">
      <div className="text-green-500">
        <IconPricing />
      </div>
      <div className="line-clamp-1 text-ellipsis text-xs font-semibold text-gray-800">
        {priceRange}
      </div>
    </div>
  )
}

export default PriceRangeDisplay
